module.exports = "https://static.web-explore.prod.moonpig.net/_next/static/images/thuiswinkel-ac454a987268d5cddf48d03321005838.svg";